import React from 'react';
import { Message, Input, Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import api from 'api';
import actions from 'actions';

function OrganisationChooser({
  searchCode, organisationSearching, errorMessage, onError, onUpdateCode, onUpdateSearching, onSelectOrganisation, t,
}) {
  const searchByCode = () => {
    onUpdateSearching(true);
    onError('');
    api.organisations.getByCode(searchCode, (organisation) => {
      onSelectOrganisation(organisation);
      onUpdateSearching(false);
    }, () => {
      onError(t('entry.register.org.error'));
      onUpdateSearching(false);
    });
  };

  return (
    <>
      <p>{t('entry.register.org.title')}</p>
      {errorMessage && <Message warning>{errorMessage}</Message>}
      <Input fluid label=".simplydo.co.uk" labelPosition="right" name="orgCode" placeholder={t('entry.register.org.placeholder')} value={searchCode} onKeyDown={e => e.keyCode === 13 && searchByCode()} onChange={e => onUpdateCode(e.target.value)} />

      <div style={{ marginTop: 15, marginBottom: 10, textAlign: 'right' }}>
        <a href="http://help.simplydo.co.uk/en/articles/3187131-what-is-my-organisational-signup-code" target="_blank" rel="noopener noreferrer">{t('entry.register.unknownCode')}</a>
      </div>
      {searchCode
        && <Button loading={organisationSearching} fluid primary content={t('generic.continue')} onClick={searchByCode} />
      }
    </>
  );
}

const mapStateToProps = state => ({ organisation: state.organisations.urlOrganisation, searchCode: state.entry.organisationSearchCode, errorMessage: state.entry.error });
const mapDispatchToProps = dispatch => ({
  onSelectOrganisation: org => dispatch(actions.organisations.receiveUrlOrganisation(org)),
  onUpdateCode: code => dispatch(actions.entry.updateOrganisationSearchCode(code)),
  onUpdateSearching: l => dispatch(actions.entry.updateOrganisationSearching(l)),
  onError: e => dispatch(actions.entry.updateError(e)),
});
const OrganisationChooserContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(OrganisationChooser);

export default withTranslation()(OrganisationChooserContainer);
